// extracted by mini-css-extract-plugin
export default {"item_wrapper":"PreviousCareRepeater_item_wrapper__5oawO"};